module.exports = __webpack_public_path__ + "static/img/HyeCorp.d92268ec.png";